import React, { Component } from 'react';
import { Field } from 'redux-form';
import { Input, Checkbox } from '../../../common/components/formControls';
import { Panel, Row, Col, HelpBlock } from 'react-bootstrap';
import { withNamespaces } from 'react-i18next';

const renderPanelHeadingWithValidation = ({ label, meta: { error } }) => (
	<Panel.Heading className={error ? 'has-error' : ''}>{label} <HelpBlock style={{ display: 'inline-block' }}>{error}</HelpBlock></Panel.Heading>
);

class Form extends Component {
	componentWillReceiveProps(nextProps) {
		if (this.props.currentFormValues) {
			const calculatedFields = this.getCalculatedFields(nextProps.currentFormValues);
			Object.keys(calculatedFields).forEach(field => {
				const nextValue = calculatedFields[field];
				if (this.props.currentFormValues[field] !== nextValue) {
					this.props.changeFormValue(field, nextValue);
				}
			});
		}
	}

	getCalculatedFields(values) {
		return {
			rightBrainMotorTotalNumberOfChecks: [...Array(9).keys()].map(x => values[`rightBrainMotor_${x + 1}`]).reduce((acc, current) => acc + (current ? 1 : 0), 0),
			leftBrainMotorTotalNumberOfChecks: [...Array(12).keys()].map(x => values[`leftBrainMotor_${x + 1}`]).reduce((acc, current) => acc + (current ? 1 : 0), 0),
			rightBrainSensoryTotalNumberOfChecks: [...Array(16).keys()].map(x => values[`rightBrainSensory_${x + 1}`]).reduce((acc, current) => acc + (current ? 1 : 0), 0),
			leftBrainSensoryTotalNumberOfChecks: [...Array(12).keys()].map(x => values[`leftBrainSensory_${x + 1}`]).reduce((acc, current) => acc + (current ? 1 : 0), 0),
			rightBrainEmotionalTotalNumberOfChecks: [...Array(10).keys()].map(x => values[`rightBrainEmotional_${x + 1}`]).reduce((acc, current) => acc + (current ? 1 : 0), 0),
			leftBrainEmotionalTotalNumberOfChecks: [...Array(13).keys()].map(x => values[`leftBrainEmotional_${x + 1}`]).reduce((acc, current) => acc + (current ? 1 : 0), 0),
			rightBrainBehavioralTotalNumberOfChecks: [...Array(23).keys()].map(x => values[`rightBrainBehavioral_${x + 1}`]).reduce((acc, current) => acc + (current ? 1 : 0), 0),
			leftBrainBehavioralTotalNumberOfChecks: [...Array(16).keys()].map(x => values[`leftBrainBehavioral_${x + 1}`]).reduce((acc, current) => acc + (current ? 1 : 0), 0),
			rightBrainAcademicTotalNumberOfChecks: [...Array(28).keys()].map(x => values[`rightBrainAcademic_${x + 1}`]).reduce((acc, current) => acc + (current ? 1 : 0), 0),
			leftBrainAcademicTotalNumberOfChecks: [...Array(36).keys()].map(x => values[`leftBrainAcademic_${x + 1}`]).reduce((acc, current) => acc + (current ? 1 : 0), 0),
			rightBrainImmuneTotalNumberOfChecks: [...Array(6).keys()].map(x => values[`rightBrainImmune_${x + 1}`]).reduce((acc, current) => acc + (current ? 1 : 0), 0),
			leftBrainImmuneTotalNumberOfChecks: [...Array(6).keys()].map(x => values[`leftBrainImmune_${x + 1}`]).reduce((acc, current) => acc + (current ? 1 : 0), 0),
			rightBrainAutonomicTotalNumberOfChecks: [...Array(6).keys()].map(x => values[`rightBrainAutonomic_${x + 1}`]).reduce((acc, current) => acc + (current ? 1 : 0), 0),
			leftBrainAutonomicTotalNumberOfChecks: [...Array(6).keys()].map(x => values[`leftBrainAutonomic_${x + 1}`]).reduce((acc, current) => acc + (current ? 1 : 0), 0),
			totalAllRightBrainChecks: values.rightBrainMotorTotalNumberOfChecks + values.rightBrainSensoryTotalNumberOfChecks +
				values.rightBrainEmotionalTotalNumberOfChecks + values.rightBrainBehavioralTotalNumberOfChecks + values.rightBrainAcademicTotalNumberOfChecks +
				values.rightBrainImmuneTotalNumberOfChecks + values.rightBrainAutonomicTotalNumberOfChecks,
			totalAllLeftBrainChecks: values.leftBrainMotorTotalNumberOfChecks + values.leftBrainSensoryTotalNumberOfChecks +
				values.leftBrainEmotionalTotalNumberOfChecks + values.leftBrainBehavioralTotalNumberOfChecks + values.leftBrainAcademicTotalNumberOfChecks +
				values.leftBrainImmuneTotalNumberOfChecks + values.leftBrainAutonomicTotalNumberOfChecks,
			rightOrLeft: Math.abs(values.totalAllRightBrainChecks - values.totalAllLeftBrainChecks) +
				(values.totalAllRightBrainChecks > values.totalAllLeftBrainChecks ? 'R' : (values.totalAllRightBrainChecks < values.totalAllLeftBrainChecks ? 'L' : ''))
		};
	}

	render() {
		const { t, isReadOnly, showResults } = this.props;
		const colSize = { labelCol: 1, valueCol: 11 };
		const totalColSize = { labelCol: 6, valueCol: 4 };
		const singleTotalColSize = { labelCol: 3, valueCol: 2 };

		const descriptionStyle = {
			marginBottom: '10px'
		};

		const rightBrainMotorFields = [...Array(9).keys()]
			.map(x => <Field name={`rightBrainMotor_${x + 1}`} component={Checkbox} horizontal label={t(`RightBrainMotor_${x + 1}`)} disabled={isReadOnly} {...colSize} />);

		const leftBrainMotorFields = [...Array(12).keys()]
			.map(x => <Field name={`leftBrainMotor_${x + 1}`} component={Checkbox} horizontal label={t(`LeftBrainMotor_${x + 1}`)} disabled={isReadOnly} {...colSize} />);

		const rightBrainSensoryFields = [...Array(16).keys()]
			.map(x => <Field name={`rightBrainSensory_${x + 1}`} component={Checkbox} horizontal label={t(`RightBrainSensory_${x + 1}`)} disabled={isReadOnly} {...colSize} />);

		const leftBrainSensoryFields = [...Array(12).keys()]
			.map(x => <Field name={`leftBrainSensory_${x + 1}`} component={Checkbox} horizontal label={t(`LeftBrainSensory_${x + 1}`)} disabled={isReadOnly} {...colSize} />);

		const rightBrainEmotionalFields = [...Array(10).keys()]
			.map(x => <Field name={`rightBrainEmotional_${x + 1}`} component={Checkbox} horizontal label={t(`RightBrainEmotional_${x + 1}`)} disabled={isReadOnly} {...colSize} />);

		const leftBrainEmotionalFields = [...Array(13).keys()]
			.map(x => <Field name={`leftBrainEmotional_${x + 1}`} component={Checkbox} horizontal label={t(`LeftBrainEmotional_${x + 1}`)} disabled={isReadOnly} {...colSize} />);

		const rightBrainBehavioralFields = [...Array(23).keys()]
			.map(x => <Field name={`rightBrainBehavioral_${x + 1}`} component={Checkbox} horizontal label={t(`RightBrainBehavioral_${x + 1}`)} disabled={isReadOnly} {...colSize} />);

		const leftBrainBehavioralFields = [...Array(16).keys()]
			.map(x => <Field name={`leftBrainBehavioral_${x + 1}`} component={Checkbox} horizontal label={t(`LeftBrainBehavioral_${x + 1}`)} disabled={isReadOnly} {...colSize} />);

		const rightBrainAcademicFields = [...Array(28).keys()]
			.map(x => <Field name={`rightBrainAcademic_${x + 1}`} component={Checkbox} horizontal label={t(`RightBrainAcademic_${x + 1}`)} disabled={isReadOnly} {...colSize} />);

		const leftBrainAcademicFields = [...Array(36).keys()]
			.map(x => <Field name={`leftBrainAcademic_${x + 1}`} component={Checkbox} horizontal label={t(`LeftBrainAcademic_${x + 1}`)} disabled={isReadOnly} {...colSize} />);

		const rightBrainImmuneFields = [...Array(6).keys()]
			.map(x => <Field name={`rightBrainImmune_${x + 1}`} component={Checkbox} horizontal label={t(`RightBrainImmune_${x + 1}`)} disabled={isReadOnly} {...colSize} />);

		const leftBrainImmuneFields = [...Array(6).keys()]
			.map(x => <Field name={`leftBrainImmune_${x + 1}`} component={Checkbox} horizontal label={t(`LeftBrainImmune_${x + 1}`)} disabled={isReadOnly} {...colSize} />);

		const rightBrainAutonomicFields = [...Array(6).keys()]
			.map(x => <Field name={`rightBrainAutonomic_${x + 1}`} component={Checkbox} horizontal label={t(`RightBrainAutonomic_${x + 1}`)} disabled={isReadOnly} {...colSize} />);

		const leftBrainAutonomicFields = [...Array(2).keys()]
			.map(x => <Field name={`leftBrainAutonomic_${x + 1}`} component={Checkbox} horizontal label={t(`LeftBrainAutonomic_${x + 1}`)} disabled={isReadOnly} {...colSize} />);

		return <div>
			<div style={descriptionStyle}>{t('Description1')}</div>
			<div style={descriptionStyle}>{t('Description2')}</div>
			<Panel>
				<Panel.Heading>{t('RightBrainMotor')}</Panel.Heading>
				<Panel.Body>
					{rightBrainMotorFields}
					{showResults && <Field name='rightBrainMotorTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalNumberOfChecks')} {...singleTotalColSize} disabled />}
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading>{t('LeftBrainMotor')}</Panel.Heading>
				<Panel.Body>
					{leftBrainMotorFields}
					{showResults && <Row>
						<Col sm={6}>
							<Field name='leftBrainMotorTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalNumberOfChecks')} {...totalColSize} disabled />
						</Col>
					</Row>}
					{showResults && <Row>
						<Col sm={6}>
							<Field name='rightBrainMotorTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalRightBrainChecks')} {...totalColSize} disabled />
						</Col>
						<Col sm={6}>
							<Field name='leftBrainMotorTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalLeftBrainChecks')} {...totalColSize} disabled />
						</Col>
					</Row>}
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading>{t('RightBrainSensory')}</Panel.Heading>
				<Panel.Body>
					{rightBrainSensoryFields}
					{showResults && <Field name='rightBrainSensoryTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalNumberOfChecks')} {...singleTotalColSize} disabled />}
				</Panel.Body>
			</Panel>
			<Panel>
				<Field name='leftBrainSensory' component={renderPanelHeadingWithValidation} label={t('LeftBrainSensory')} />
				<Panel.Body>
					{leftBrainSensoryFields}
					{showResults && <Row>
						<Col sm={6}>
							<Field name='leftBrainSensoryTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalNumberOfChecks')} {...totalColSize} disabled />
						</Col>
					</Row>}
					{showResults && <Row>
						<Col sm={6}>
							<Field name='rightBrainSensoryTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalRightBrainChecks')} {...totalColSize} disabled />
						</Col>
						<Col sm={6}>
							<Field name='leftBrainSensoryTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalLeftBrainChecks')} {...totalColSize} disabled />
						</Col>
					</Row>}
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading>{t('RightBrainEmotional')}</Panel.Heading>
				<Panel.Body>
					{rightBrainEmotionalFields}
					{showResults && <Field name='rightBrainEmotionalTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalNumberOfChecks')} {...singleTotalColSize} disabled />}
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading>{t('LeftBrainEmotional')}</Panel.Heading>
				<Panel.Body>
					{leftBrainEmotionalFields}
					{showResults && <Row>
						<Col sm={6}>
							<Field name='leftBrainEmotionalTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalNumberOfChecks')} {...totalColSize} disabled />
						</Col>
					</Row>}
					{showResults && <Row>
						<Col sm={6}>
							<Field name='rightBrainEmotionalTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalRightBrainChecks')} {...totalColSize} disabled />
						</Col>
						<Col sm={6}>
							<Field name='leftBrainEmotionalTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalLeftBrainChecks')} {...totalColSize} disabled />
						</Col>
					</Row>}
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading>{t('RightBrainBehavioral')}</Panel.Heading>
				<Panel.Body>
					{rightBrainBehavioralFields}
					{showResults && <Field name='rightBrainBehavioralTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalNumberOfChecks')} {...singleTotalColSize} disabled />}
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading>{t('LeftBrainBehavioral')}</Panel.Heading>
				<Panel.Body>
					{leftBrainBehavioralFields}
					{showResults && <Row>
						<Col sm={6}>
							<Field name='leftBrainBehavioralTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalNumberOfChecks')} {...totalColSize} disabled />
						</Col>
					</Row>}
					{showResults && <Row>
						<Col sm={6}>
							<Field name='rightBrainBehavioralTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalRightBrainChecks')} {...totalColSize} disabled />
						</Col>
						<Col sm={6}>
							<Field name='leftBrainBehavioralTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalLeftBrainChecks')} {...totalColSize} disabled />
						</Col>
					</Row>}
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading>
					{t('RightBrainAcademic')}
					<div>{t('RightBrainAcademicDescription')}</div>
				</Panel.Heading>
				<Panel.Body>
					{rightBrainAcademicFields}
					{showResults && <Field name='rightBrainAcademicTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalNumberOfChecks')} {...singleTotalColSize} disabled />}
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading>
					{t('LeftBrainAcademic')}
					<div>{t('LeftBrainAcademicDescription')}</div>
				</Panel.Heading>
				<Panel.Body>
					{leftBrainAcademicFields}
					{showResults && <Row>
						<Col sm={6}>
							<Field name='leftBrainAcademicTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalNumberOfChecks')} {...totalColSize} disabled />
						</Col>
					</Row>}
					{showResults && <Row>
						<Col sm={6}>
							<Field name='rightBrainAcademicTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalRightBrainChecks')} {...totalColSize} disabled />
						</Col>
						<Col sm={6}>
							<Field name='leftBrainAcademicTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalLeftBrainChecks')} {...totalColSize} disabled />
						</Col>
					</Row>}
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading>{t('RightBrainImmune')}</Panel.Heading>
				<Panel.Body>
					{rightBrainImmuneFields}
					{showResults && <Field name='rightBrainImmuneTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalNumberOfChecks')} {...singleTotalColSize} disabled />}
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading>{t('LeftBrainImmune')}</Panel.Heading>
				<Panel.Body>
					{leftBrainImmuneFields}
					{showResults && <Row>
						<Col sm={6}>
							<Field name='leftBrainImmuneTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalNumberOfChecks')} {...totalColSize} disabled />
						</Col>
					</Row>}
					{showResults && <Row>
						<Col sm={6}>
							<Field name='rightBrainImmuneTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalRightBrainChecks')} {...totalColSize} disabled />
						</Col>
						<Col sm={6}>
							<Field name='leftBrainImmuneTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalLeftBrainChecks')} {...totalColSize} disabled />
						</Col>
					</Row>}
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading>{t('RightBrainAutonomic')}</Panel.Heading>
				<Panel.Body>
					{rightBrainAutonomicFields}
					{showResults && <Field name='rightBrainAutonomicTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalNumberOfChecks')} {...singleTotalColSize} disabled />}
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading>{t('LeftBrainAutonomic')}</Panel.Heading>
				<Panel.Body>
					{leftBrainAutonomicFields}
					{showResults && <Row>
						<Col sm={6}>
							<Field name='leftBrainAutonomicTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalNumberOfChecks')} {...totalColSize} disabled />
						</Col>
					</Row>}
					{showResults && <Row>
						<Col sm={6}>
							<Field name='rightBrainAutonomicTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalRightBrainChecks')} {...totalColSize} disabled />
						</Col>
						<Col sm={6}>
							<Field name='leftBrainAutonomicTotalNumberOfChecks' component={Input} horizontal type='text' label={t('TotalLeftBrainChecks')} {...totalColSize} disabled />
						</Col>
					</Row>}
				</Panel.Body>
			</Panel>
			{showResults && <Panel>
				<Panel.Heading>{t('TotalAll')}</Panel.Heading>
				<Panel.Body>
					<Field name='totalAllRightBrainChecks' component={Input} horizontal type='text' label={t('TotalAllRightBrainChecks')} labelCol={5} valueCol={2} disabled />
					<Field name='totalAllLeftBrainChecks' component={Input} horizontal type='text' label={t('TotalAllLeftBrainChecks')} labelCol={5} valueCol={2} disabled />
					<Field name='rightOrLeft' component={Input} horizontal type='text' label={t('RightOrLeft')} labelCol={5} valueCol={2} disabled />
				</Panel.Body>
			</Panel>}
			<div style={{ marginBottom: 20 }}>{t('FormDescription')}</div>
		</div>;
	}
}


export default withNamespaces(props => props.resourcesNamespace)(Form);

export const RequiredFields = [

];

export const ValidationFunc = (values, t) => {
	let errors = {};

	if (!values.leftBrainSensoryTotalNumberOfChecks) {
		errors['leftBrainSensory'] = t('Validator_Section_Required');
	}

	return errors;
};